import { View, styled } from 'tamagui'
import type { UserStatus } from '@/types'

const statusColors: Record<UserStatus, string> = {
  online: '#3ECF7B',
  idle: '#E8A840',
  dnd: '#CF3E4F',
  offline: '#505A6E',
}

const Dot = styled(View, {
  borderRadius: '$borderRadiusFull',
})

interface StatusDotProps {
  status: UserStatus
  size?: number
}

export function StatusDot({ status, size = 10 }: StatusDotProps) {
  return (
    <Dot
      width={size}
      height={size}
      backgroundColor={statusColors[status]}
    />
  )
}
